module.exports = __webpack_public_path__ + "img/icon_menu_order_main.6b749c9c.svg";